import { GoQuestion } from "react-icons/go";
import { ReactNode } from "react";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover/popover";

type HelperButtonProps = {
  children: ReactNode;
};

export const HelperButton = ({ children }: HelperButtonProps) => {
  return (
    <Popover>
      <PopoverTrigger>
        <span className="cursor-pointer">
          <GoQuestion className="h-3 w-3" />
        </span>
      </PopoverTrigger>
      <PopoverContent className="w-[280px] text-[14px]">
        {children}
      </PopoverContent>
    </Popover>
  );
};
